<app-view-item *ngIf="readonly && selected" [text]="selected ? selected.code : ''"
  [borderless]="borderless"></app-view-item>
<app-view-item *ngIf="readonly && !selected" [text]="''" [borderless]="borderless"></app-view-item>

<nz-select 
*ngIf="!readonly" 
#selector
nzShowSearch 
nzServerSearch 
[nzAllowClear]="true" 
[nzBackdrop]="addBackdrop"
[nzFilterOption]="nzFilterOption" 
(nzOnSearch)="search($event, 20)" 
(nzOpenChange)="search('')"
(nzScrollToBottom)="loadMore()"
(keydown)="handleKeyDown($event)"
(click)="handleClick($event)"

[nzCustomTemplate]="displayTpl" 
[(ngModel)]="value" 
(ngModelChange)="valueChanged($event)"
[nzDropdownMatchSelectWidth]="false" 
[nzBorderless]="borderless" 
[nzMode]="mode"
class="width-100">

  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option
      *ngIf="!searching"
      [nzValue]="getValue(o)"
      [nzLabel]="o.code"
      nzCustomContent
    >
    <strong>{{ o.code }}</strong>
    <span *ngIf="o.name && o.name.trim() !== ''">:</span>
    <span> {{ o.name }}</span>
    </nz-option>
  </ng-container>
</nz-select>
